import React from "react";
import styles from "./flippableCard.module.css";

export default function FlippableCard({
  Back,
  children,
  onClick,
  className,
  style,
  borderSize,
  borda,
  borda_back,
  frontClassName,
  backClassName,
  ref,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`${styles.card} ${className || ""}`}
      style={style}
      ref={ref}
    >
      <div className={`${styles.back} ${backClassName || ""}`}>
        <div
          className={styles.cardContent}
          style={{
            borderImageSource: `url(${borda_back})`,
            borderImageWidth: borderSize ? `${borderSize}px` : undefined,
          }}
        >
          {Back ? <Back /> : null}
        </div>
      </div>
      <div className={`${styles.front} ${frontClassName || ""}`}>
        <div
          className={styles.cardContent}
          style={{
            borderImageSource: `url(${borda})`,
            borderImageWidth: borderSize ? `${borderSize}px` : undefined,
          }}
        >
          {children ? children : null}
        </div>
      </div>
    </button>
  );
}
